"use client";
import React from "react";
import Pill from "../common/Pill";
import Button from "../common/Button";
import FeaturesBar from "../common/Features-Bar"

const AgentCard = () => {
  return (
    <section className="flex justify-center items-center bg-[#FFF7EB] px-4">
      <div className="py-10 w-full flex justify-center ">
        <div className="relative flex flex-col items-center rounded-3xl bg-[#211E1D] text-white w-full max-w-4xl text-center px-6 sm:px-8 py-8 shadow-lg overflow-hidden">
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[400px] sm:w-[500px] h-[150px] sm:h-[200px] rounded-[353px] blur-3xl bg-gradient-to-t from-[#B2222200] via-[#B22222] to-[#B2222200] pointer-events-none z-0"></div>
          <div className="absolute top-0 left-0 w-full h-[120px] sm:h-[180px] bg-gradient-to-b from-[#FFFFFF66] via-[#FFFFFF1A] to-transparent opacity-[30%] pointer-events-none z-10 rounded-t-3xl"></div>
          <div className="flex flex-col gap-4 rounded-2xl px-4 sm:px-6 py-4 mb-4 z-20">
            <div className="flex justify-center mb-3 sm:mb-4">
              <Pill text="Still Thinking?" backgroundColor="#FFFFFF1A" />
            </div>

            <h2 className="text-xl sm:text-2xl md:text-[46px]  max-w-xl font-semibold mb-2 mx-auto" style={{lineHeight:"60px"}}>
              Try Building a Simple Voice AI Agent For Free
            </h2>
            <div className="w-full sm:w-fit mx-auto">
              <FeaturesBar />
            </div>
            <p className="text-gray-300 text-xs sm:text-sm mt-2">
              Serve your customers anywhere they need
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-[10px] w-full sm:w-auto z-20">
            <Button text="Try For Free"  path="https://app.agoravoice.ai"/>
            <Button text="Watch Demo" path="https://www.youtube.com/watch?v=uL39k1aUzA0&t" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentCard;
